var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseEntity } from "../../../pages/modules/base-entity";
import { StepEnum } from "../../../../models/modules/lotteryplatofrm.models";
import { EntityTypes } from "../../../../models/basics/basics.models";
import { RouterConstants } from "../../../../configuration/router.constants";
import { Router } from "aurelia-router";
import { BindingEngine } from "aurelia-binding";
import { I18N } from "aurelia-i18n";
import { NotificationClientService } from "../../../../services/basics/notification-client.service";
import { EventAggregator } from "aurelia-event-aggregator";
import { TransactionClientService } from "../../../../services/modules/transaction-client.service";
import { autoinject, transient } from "aurelia-framework";
import { TransactionTickets } from "./steps/transaction-tickets";
import { TransactionVideos } from "./steps/transaction-videos";
var Transaction = /** @class */ (function (_super) {
    __extends(Transaction, _super);
    function Transaction(transactionClientService, router, bindingEngine, i18N, notificationService, eventAggregator, transactionTickets, transactionVideos) {
        var _this = _super.call(this, router, bindingEngine, i18N, notificationService, eventAggregator) || this;
        _this.transactionClientService = transactionClientService;
        _this.router = router;
        _this.bindingEngine = bindingEngine;
        _this.i18N = i18N;
        _this.notificationService = notificationService;
        _this.eventAggregator = eventAggregator;
        _this.transactionTickets = transactionTickets;
        _this.transactionVideos = transactionVideos;
        return _this;
    }
    Transaction.prototype.getListRoute = function () {
        return RouterConstants.RouteNames.ListTransactions;
    };
    Transaction.prototype.getItem = function (id) {
        return this.transactionClientService.getTransaction({ id: id });
    };
    Transaction.prototype.getItemId = function () {
        return this.item.transactionId;
    };
    Transaction.prototype.getUpdateRoute = function () {
        return RouterConstants.RouteNames.ManageTransaction;
    };
    Transaction.prototype.getEntityType = function () {
        return EntityTypes.Transaction;
    };
    Transaction.prototype.initializeItemForCreate = function () {
        //not needed for now as there will be no transaction created from here.
        throw new Error("Method not implemented.");
    };
    Transaction.prototype.getSteps = function () {
        return [
            {
                title: this.i18N.tr("transaction-tickets"),
                step: StepEnum.TransactionTickets,
                vm: this.transactionTickets,
                show: true,
                view: "../../app/admin/transaction/steps/transaction-tickets.html"
            },
            {
                title: this.i18N.tr("transaction-videos"),
                step: StepEnum.TransactionVideos,
                vm: this.transactionVideos,
                show: true,
                view: "../../app/admin/transaction/steps/transaction-videos.html"
            }
        ];
    };
    Transaction.prototype.saveItem = function (id, changes) {
        return null;
    };
    Transaction = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [TransactionClientService, Router,
            BindingEngine,
            I18N,
            NotificationClientService,
            EventAggregator,
            TransactionTickets,
            TransactionVideos])
    ], Transaction);
    return Transaction;
}(BaseEntity));
export { Transaction };
